"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissionRequiredMessage = exports.LabelDetailMessageElement = exports.LabelDetailMessageId = exports.LabelDetailDateElement = exports.LabelDetailAsset = exports.LabelDetailAuthorElementInner = exports.LabelDetailAuthorElement = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../.././../../gen-src/Localize");
var UserDisplayComponent_1 = require("../../UserDisplayComponent");
var ViewerPaneLayoutComponents_1 = require("../../ViewerPaneLayoutComponents");
var MarkupStyles_1 = require("../../style/MarkupStyles");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
var StringInterpolation_1 = require("../../utils/StringInterpolation");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var LabelHelpers_1 = require("../LabelHelpers");
var Styles_1 = require("../Styles");
function LabelDetailAuthorElement(props) {
    return (react_1.default.createElement(Styles_1.LabelDetailAuthorStyle, null,
        react_1.default.createElement(LabelDetailAuthorElementInner, __assign({}, props))));
}
exports.LabelDetailAuthorElement = LabelDetailAuthorElement;
function LabelDetailAuthorLink(props) {
    return react_1.default.createElement("a", { href: props.url, target: '_blank', className: VizPortalStyles_1.linkClass, title: props.name, rel: "noreferrer" }, props.name);
}
function LabelDetailAuthorElementInner(props) {
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    var userElement = (linksDisabled || !props.author.domain)
        ? react_1.default.createElement(UserDisplayComponent_1.UserTextDisplayComponent, { user: props.author })
        : react_1.default.createElement(UserDisplayComponent_1.UserLinkDisplayComponent, { user: props.author, linkComponent: LabelDetailAuthorLink });
    var name = '[AUTHOR_NAME_TOKEN]';
    var span = react_1.default.createElement("span", { key: 'author', "data-tb-test-id": 'Data-Quality-Detail-Author' }, userElement);
    switch (props.category) {
        case 'warning':
            return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(Localize_1.Messages.DataQualityAuthor({ name: name }), { 'AUTHOR_NAME_TOKEN': span })));
        case 'certification':
            return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(Localize_1.Messages.DataQualityCertificationAuthor({ name: name }), { 'AUTHOR_NAME_TOKEN': span })));
        case 'sensitivity':
            return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(Localize_1.Messages.DataQualityAuthor({ name: name }), { 'AUTHOR_NAME_TOKEN': span })));
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
exports.LabelDetailAuthorElementInner = LabelDetailAuthorElementInner;
function LabelDetailAsset(props) {
    var _a, _b, _c, _d, _e, _f;
    if (props.assetName == null) {
        return getPermissionRequiredMessage();
    }
    var iconComponent = (0, LabelHelpers_1.assetIconForType)(props.assetType, props.remoteType);
    if (props.parentName) {
        var renderText = props.assetName + ' (table ' + props.parentName + ')';
        return (react_1.default.createElement(Styles_1.LabelDetailAssetStyle, null, props.assetUrl ?
            react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineLinkWithSubLinkIcon, { linkText: (_a = props.assetName) !== null && _a !== void 0 ? _a : null, linkHref: (_b = props.assetUrl) !== null && _b !== void 0 ? _b : '', iconComponent: iconComponent, iconSize: 'small', subLinkText: (_c = props.parentName) !== null && _c !== void 0 ? _c : null, subLinkHref: (_d = props.parentUrl) !== null && _d !== void 0 ? _d : '', subPrefixText: ' (table ', subSuffixText: ')' }) :
            react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: renderText, iconComponent: iconComponent, iconSize: 'small' })));
    }
    return (react_1.default.createElement(Styles_1.LabelDetailAssetStyle, null, props.assetUrl ?
        react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineLinkWithIcon, { linkText: (_e = props.assetName) !== null && _e !== void 0 ? _e : null, linkHref: (_f = props.assetUrl) !== null && _f !== void 0 ? _f : '', iconComponent: iconComponent, iconSize: 'small' }) :
        react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: props.assetName || null, iconComponent: iconComponent, iconSize: 'small' })));
}
exports.LabelDetailAsset = LabelDetailAsset;
function LabelDetailDateElement(props) {
    return (react_1.default.createElement(Styles_1.LabelDetailDateStyle, null, props.updatedAt));
}
exports.LabelDetailDateElement = LabelDetailDateElement;
exports.LabelDetailMessageId = 'data-quality-detail-message-id';
function LabelDetailMessageElement(props) {
    if (props.assetName === null) {
        return (react_1.default.createElement(Styles_1.LabelDetailMessageStyle, { id: exports.LabelDetailMessageId }, Localize_1.Messages.PermissionRequiredMessage()));
    }
    return (react_1.default.createElement(Styles_1.LabelDetailMessageStyle, null,
        react_1.default.createElement(MarkupOrSplitString, __assign({}, props))));
}
exports.LabelDetailMessageElement = LabelDetailMessageElement;
function MarkupOrSplitString(props) {
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    var messageOrBlank = props.message || '';
    return (react_1.default.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: messageOrBlank, linksDisabled: linksDisabled }));
}
function getPermissionRequiredMessage() {
    var name = Localize_1.Messages.PermissionRequired();
    return react_1.default.createElement("span", { key: 'asset-' + name, style: Styles_1.LabelDetailPermissionRequired }, name);
}
exports.getPermissionRequiredMessage = getPermissionRequiredMessage;
//# sourceMappingURL=LabelPopoverDetail.js.map